import { Box, Container, useTheme } from '@mui/material';
import { RefObject } from 'react';

import { ChatWindowMessage } from './ChatWindowMessage';
import { ChatWindowProps } from './ChatWindowTypes';

interface ChatWindowMessagesProps {
  messages: ChatWindowProps['messages'];
  userInitials?: string;
  chatWindowRef: RefObject<HTMLDivElement>;
  messagesEndRef: RefObject<HTMLDivElement>;
  /** Extra bottom padding for scroll-to-top room (used by inline progress mode) */
  scrollPaddingBottom?: string;
}

export const ChatWindowMessages = ({
  messages,
  userInitials,
  chatWindowRef,
  messagesEndRef,
  scrollPaddingBottom,
}: ChatWindowMessagesProps) => {
  const theme = useTheme();

  return (
    <Container
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        flexGrow: 1,
        padding: `${theme.spacing(1)} ${theme.spacing(3)} !important`,
        overflow: 'auto',
      }}
    >
      <Box
        sx={{ flexGrow: 1, width: '100%', paddingBottom: scrollPaddingBottom ?? 0 }}
        ref={chatWindowRef}
      >
        {messages?.map((message, i) => (
          <ChatWindowMessage key={i} message={message} index={i} userInitials={userInitials} />
        ))}

        <div ref={messagesEndRef} />
      </Box>
    </Container>
  );
};
